<template>
  <div class="main technologyListMain">
    <!-- 顶部 -->
    <div class="top">
      <img class="goback" src="../assets/back.png" @click="goback" />
      <span>返回</span>
      <div class="score">
        <span style="color: #606266;margin-right: 10px;">自评分:</span>
        <span style="color: #00b0f0;font-size: 36px;">{{score}}</span>
      </div>
    </div>
    <!-- 表格部分 -->
    <div class="caption">
      <p>上海市既有建筑绿色更新改造适用技术目录</p>
      <span v-if="this.$route.query.isSubmitted === 'true'" style="color: #f00;">（请根据审核意见，修改申报技术；无修改则直接点击提交。）</span>
    </div>
    <el-tabs type="border-card" v-model="activeName" @tab-click="changePane">
      <el-tab-pane
        v-for="(pane, index) in paneList"
        :key="index"
        :label="pane.label"
        :name="pane.name"
      >
        <el-table :data="tableData" style="width:99%;" border stripe>
          <el-table-column prop="number" label="序号" align="center" width="80"></el-table-column>
          <el-table-column prop="technology_name" label="技术名称" align="center"></el-table-column>
          <el-table-column prop="technology_category" label="技术类别" align="center">
            <template slot-scope="scope">
              <p>{{scope.row.technology_category === '1' ? '推荐技术' : scope.row.technology_category === '2' ? '重点技术' : '-'}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="sphere_application" label="适用范围" align="center" min-width="150"></el-table-column>
          <el-table-column label="状态" align="center" width="120">
            <template slot-scope="scope">
              <i
                v-if="scope.row.level_id"
                class="el-icon-success"
                style="font-size: 32px;color: #409eff;"
              ></i>
              <img v-else src="../assets/no.png" />
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                round
                size="mini"
                plain
                :disabled="!!scope.row.technology_introduce"
                @click="addIntroduce(scope.row)"
              >添加介绍</el-button>
              <el-button
                :disabled="!scope.row.level_id"
                type="danger"
                round
                size="mini"
                plain
                @click="del(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="创新" name="8">
        <el-table :data="tableData2" style="width:99%;" border stripe>
          <el-table-column prop="it_name" label="技术名称" align="center"></el-table-column>
          <el-table-column prop="grade" label="自评分数" align="center"></el-table-column>
          <el-table-column prop="introduce" label="情况说明" align="center" min-width="400"></el-table-column>
          <el-table-column :render-header="renderHeader" align="center">
            <template slot-scope="scope">
              <el-button type="danger" round size="mini" plain @click="delInnovate(scope.row)">删除</el-button>
              <!-- <el-button
                type="primary"
                round
                size="mini"
                plain
                @click="updateInnovate(scope.row)"
              >修改</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="沿用" name="9">
        <div class="textContent">
          <p>若对照《上海市既有建筑绿色更新改造适用技术目录》存在自该建筑竣工起沿用至今的技术，</p>
          <p>请在此处上传该项目的沿用技术文档，具体格式请下载模板查看，填写完毕后在此页面上传。</p>
        </div>
        <div style="display: flex;justify-content: center;">
          <div>
            <el-button
              type="primary"
              @click="downloadTemplate"
              size="small"
              style="margin-right: 200px;"
            >下载模板</el-button>
          </div>
          <FileUploader
            :fileList="declarefileList"
            :handleChange="handleChange3"
            :level_id="this.level_id"
            :delFromServer="delFromServer3"
            :backFileList="backDeclareFileList"
          />
          <div>
            <el-button type="primary" size="small" @click="createDeclare" :loading="loading">上传</el-button>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div style="text-align: center;margin: 20px 0">
      <el-button type="primary" @click="tampSave">暂存</el-button>
      <el-button v-if="this.$route.query.isSubmitted === 'true'" type="primary" @click="next">提交</el-button>
      <el-button v-else type="primary" @click="next">下一步</el-button>
    </div>
    <el-dialog
      title="查看技术/添加操作"
      :close-on-click-modal="false"
      :visible.sync="isShowIntroduce"
      width="80%"
      top="1vh"
      @close="closeIntroduce('form')"
    >
      <div class="theme">
        <div class="blueBg">
          <span class="name">
            <i class="el-icon-s-flag"></i>
            技术内容说明({{number}} {{technology_name}})
          </span>
        </div>
      </div>
      <p class="technologyContent" v-html="technology_content"></p>
      <div class="theme">
        <div class="blueBg">
          <span class="name">
            <i class="el-icon-s-flag"></i>
            申报技术情况介绍
          </span>
        </div>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="技术证明材料：" prop="dlfileaddress">
          <FileUploader
            :fileList="form.dlfileaddress"
            :handleChange="handleChange"
            :backFileList="form.backDlFileAddress"
            :level_id="this.level_id"
            :delFromServer="delFromServer"
          />
        </el-form-item>
        <el-form-item label="简介及介绍：" prop="technology_introduce">
          <el-input
            type="textarea"
            v-model="form.technology_introduce"
            :autosize="{ minRows: 5, maxRows: 8}"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center;">
          <el-button type="primary" @click="sure" :loading="loading1">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="承诺书"
      :close-on-click-modal="false"
      :visible.sync="isShowPromise"
      width="80%"
      top="1vh"
    >
      <div class="promiseMain">
        <div class="promiseTitle">上海市既有建筑绿色更新改造评定申报承诺书</div>
        <div class="promiseContent">
          <div>上海市绿色建筑协会：</div>
          <div class="promiseText">
            <span>根据《关于开展上海市既有建筑绿色更新改造评定的通知》和《上海市既有建筑绿色更新改造评定实施细则（试行）》，在充分了解上海市既有建筑绿色更新改造评定规定和申报程序的基础上，我单位</span>
            <input v-model="promise" disabled size="40" class="promiseInput" type="text" />
            <span>项目决定申请上海市既有建筑绿色更新改造评定，并承诺如下：</span>
          </div>
          <div class="promiseText">1.本项目中的改造技术均已实施完成并投入使用。</div>
          <div
            class="promiseText"
          >2.在提交本声明之日起5个工作日内将申报材料递交贵协会。如在评定过程中收到贵单位发出的需补充材料的通知单，按照通知单的要求在规定期限内补充评定相关材料。</div>
          <div class="promiseText">3.提交的申报资料满足上海市既有建筑绿色更新改造评定申报的相关要求，并保证资料的准确性和真实性，如有虚假，自动取消参评资格。</div>
          <div class="promiseText">4.申报材料提交后，未经贵协会许可，不会退出评定活动。</div>
          <div class="promiseText">5.配合协会基于上海市既有建筑绿色更新改造评定开展的相关工作。</div>
          <div class="promiseText">6.如无法按贵协会规定提交资料，我单位同意终止评定。</div>
          <div class="promiseText">7.如未按本声明履行义务，后果自负。</div>
          <div style="margin-top: 30px">特此声明。</div>
          <div style="text-align: right;">主申报单位盖章</div>
          <div style="text-align: right;">联合申报单位盖章</div>
          <div style="text-align: right;">
            <span>年</span>
            <span style="margin-left: 30px;">月</span>
            <span style="margin-left: 30px;">日</span>
          </div>
        </div>
        <div style="text-align: center;">
          <el-button @click="submitPromise" type="primary">确定，下一步</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="addInnovate"
      :title="isUpdateInnovate ? '修改创新项' : '添加创新项'"
      :close-on-click-modal="false"
      :visible.sync="isShowInnovate"
      width="70%"
      top="5vh"
      @close="closeInnovateDialog('innovateForm')"
    >
      <el-form
        ref="innovateForm"
        :model="innovateForm"
        :rules="innovateRules"
        label-width="140px"
        style="margin: 40px 0;"
      >
        <el-form-item label="创新项名称：" prop="it_name">
          <el-input v-model="innovateForm.it_name" style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item label="情况说明：" prop="introduce">
          <el-input
            type="textarea"
            v-model="innovateForm.introduce"
            :autosize="{ minRows: 5, maxRows: 8}"
          ></el-input>
        </el-form-item>
        <el-form-item label="技术证明材料：" prop="fileaddress">
          <FileUploader
            :fileList="innovateForm.fileaddress"
            :handleChange="handleChange2"
            :backFileList="innovateForm.backFileAddress"
            :level_id="this.level_id"
            :delFromServer="delFromServer2"
          />
        </el-form-item>
        <el-form-item label="自评分数：" prop="grade">
          <el-radio-group v-model="innovateForm.grade">
            <el-radio label="1">1分</el-radio>
            <el-radio label="2">2分</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button type="primary" @click="saveInnovate('innovateForm')" :loading="loading2">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import FileUploader from '../components/FileUploader'
import config from '../config'

const { downloadUrl } = config

export default {
  components: { FileUploader },
  data () {
    return {
      loading1: false,
      loading2: false,
      isUpdateInnovate: false, // 是否是修改创新项
      level_id: '',
      allList: [], // 所有的技术目录集合
      isAddedList: [], // 已添加过介绍的技术目录的level_id集合
      loading: false,
      declarefileList: [], // 沿用页上传的文件集合
      backDeclareFileList: [],
      innovateForm: {
        it_name: '', // 创新项名称
        introduce: '', // 情况说明
        fileaddress: [], // 文件集合
        backFileAddress: [], // 服务端返回的路径集合
        grade: '' // 自评分数
      },
      innovateRules: {
        it_name: [
          { required: true, message: '请输入创新项名称', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '请输入情况说明', trigger: 'blur' }
        ],
        fileaddress: [
          { required: true, message: '请上传技术证明材料', trigger: 'change' }
        ],
        grade: [
          { required: true, message: '请选择自评分数', trigger: 'change' }
        ]
      },
      isShowInnovate: false, // 是否展示添加创新性弹框
      promise: '',
      item: {},
      paneList: [
        { label: '建筑', name: '1' },
        { label: '结构', name: '2' },
        { label: '给水排水', name: '3' },
        { label: '暖通空调', name: '4' },
        { label: '电气', name: '5' },
        { label: '施工', name: '6' },
        { label: '运营', name: '7' }
      ],
      activeName: '1',
      score: '0.0',
      tableData: [],
      tableData2: [], // 创新项表格
      isShowIntroduce: false, // 是否展示添加介绍弹框
      isShowPromise: false, // 是否展示承诺书弹框
      number: '',
      technology_name: '',
      technology_content: '',
      form: {
        backDlFileAddress: [], // 服务端返回的文件路径集合
        dlfileaddress: [],
        technology_introduce: ''
      },
      rules: {
        dlfileaddress: [
          { required: true, message: '请上传附件', trigger: 'change' }
        ],
        technology_introduce: [
          { required: true, message: '请输入简介及介绍', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.asyncGetTable()
    this.asyncGetEBByID()
  },
  methods: {
    // 查询沿用技术文件
    asyncGetDeclareFile () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.getDeclareFile(params).then(resp => {
        if (resp.resultCode === '0000') {
          let arr = []
          this.backDeclareFileList =
            resp.data === null ? arr : arr.concat(resp.data.dl_file_address)
        }
      })
    },
    delFromServer3 () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.deleteDeclareFile(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$message.success('删除成功！')
          this.asyncGetDeclareFile()
        }
      })
    },
    // 修改创新项
    updateInnovate (item) {
      this.isUpdateInnovate = true
      this.it_name = item.it_name
      this.isShowInnovate = true
      this.level_id = item.id
      this.asyncFindInnovateTechnologyInfo()
    },

    delFromServer (index) {
      this.$confirm('确定删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          project_declare_id: this.$route.query.id,
          level_id: this.level_id,
          dl_file_address: this.form.backDlFileAddress[index]
        }
        API.deleteDeclareLevelByPidLidFileaddress(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功！')
            this.asyncQueryDeclareLevelByPidAndLevelid()
          }
        })
      })
    },
    delFromServer2 (index) {
      this.$confirm('确定删除该文件吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          project_declare_id: this.$route.query.id,
          it_name: this.it_name,
          file_address: this.innovateForm.backFileAddress[index]
        }
        API.deleteInnovateTechnologyByPidItnameAddress(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功！')
            this.asyncFindInnovateTechnologyInfo()
          }
        })
      })
    },

    closeIntroduce (form) {
      this.$refs[form].resetFields()
      this.form.backDlFileAddress = []
    },
    closeInnovateDialog (form) {
      this.$refs[form].resetFields()
      this.innovateForm.backFileAddress = []
    },
    asyncGetEBByID () {
      let params = {
        id: this.$route.query.id
      }
      API.getEBByID(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.score = resp.data.all_grade.toFixed(1)
          this.promise = resp.data.items_name
        }
      })
    },

    asyncGetTable () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.getDeclareLevelByProId(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.isAddedList = resp.data
          let _params = {
            onelevelid: this.activeName
          }
          API.findTwoLevelByOneLevelid(_params).then(_resp => {
            if (_resp.resultCode === '0000') {
              this.tableData = _resp.data.map(item => {
                const newItem = this.isAddedList.find(_item => {
                  return _item.level_id === item.id
                })
                return {
                  ...item,
                  ...newItem
                }
              })
            }
          })
        }
      })
    },
    // 查看技术说明详情
    asyncQueryDeclareLevelByPidAndLevelid (item) {
      let params = {
        project_declare_id: this.$route.query.id,
        level_id: item.level_id
      }
      API.queryDeclareLevelByPidAndLevelid(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.form.technology_introduce = resp.data.technology_introduce || ''
          this.form.backDlFileAddress = resp.data.fileaddress || []
        }
      })
    },
    // 上传沿用附件
    createDeclare () {
      if (!this.declarefileList.length) {
        this.$message.error('请选择一个文件上传')
        return
      } else if (this.declarefileList.length > 1) {
        this.$message.error('只能上传一个文件')
        return
      }
      this.loading = true
      let params = {
        project_declare_id: this.$route.query.id,
        declarefile: this.declarefileList[0]
      }
      API.createDeclare(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.loading = false
          this.$message.success(resp.resultMsg)
          this.asyncGetDeclareFile()
        }
      })
    },
    // 下载模板
    downloadTemplate () {
      window.open(downloadUrl + 'existingbuildings/模板.doc', '_blank')
    },
    // 表头使用jsx渲染按钮
    renderHeader (h, { column, $index }) {
      return (
        <el-button type="primary" size="small" round onClick={this.addInnovate}>
          添加
        </el-button>
      )
    },
    // 文件改变时，调用上传接口
    handleChange (file) {
      this.form.dlfileaddress.push(file)
    },
    handleChange2 (file) {
      this.innovateForm.fileaddress.push(file)
    },
    handleChange3 (file) {
      let fileType = file.name.substring(file.name.lastIndexOf('.'))
      if (fileType !== '.doc' && fileType !== '.docx') {
        this.$message.error('请上传.doc或.docx类型的文件！')
        return
      }
      if (this.declarefileList.length > 0) {
        this.$message.error('只能上传一个文件')
        return
      }
      this.declarefileList.push(file)
    },
    addInnovate () {
      this.isUpdateInnovate = false
      this.isShowInnovate = true
    },
    // 删除创新项
    delInnovate (item) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          project_declare_id: this.$route.query.id,
          it_name: item.it_name
        }
        API.deleteInnovateTechnologyByPidAndName(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$message.success('删除成功！')
            this.asyncFindInnovateTechnologyByPid()
            this.asyncGetEBByID()
          }
        })
      })
    },
    // 单个创新项查询
    asyncFindInnovateTechnologyInfo () {
      let params = {
        project_declare_id: this.$route.query.id,
        it_name: this.it_name
      }
      API.findInnovateTechnologyInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.innovateForm = {
            ...resp.data,
            backFileAddress: resp.data.fileaddress
          }
        }
      })
    },
    // 添加，修改创新项
    saveInnovate (innovateForm) {
      this.$refs[innovateForm].validate(valid => {
        if (valid) {
          let params = {
            project_declare_id: this.$route.query.id,
            it_name: this.innovateForm.it_name,
            introduce: this.innovateForm.introduce,
            fileaddresss: this.innovateForm.fileaddress,
            grade: this.innovateForm.grade
          }
          this.loading2 = true
          if (this.isUpdateInnovate) {
            API.updateInnovateTechnology(params).then(resp => {
              if (resp.resultCode === '0000') {
                this.loading2 = false
                this.$message.success('修改成功')
                this.isShowInnovate = false
                this.asyncFindInnovateTechnologyByPid()
                this.asyncGetEBByID()
              } else {
                this.$message.error(resp.resultMsg)
              }
            })
          } else {
            API.createInnovateTechnology(params).then(resp => {
              if (resp.resultCode === '0000') {
                this.loading2 = false
                this.$message.success('保存成功')
                this.isShowInnovate = false
                this.asyncFindInnovateTechnologyByPid()
                this.asyncGetEBByID()
              } else {
                this.$message.error(resp.resultMsg)
              }
            })
          }
        }
      })
    },
    asyncFindInnovateTechnologyByPid () {
      let params = {
        project_declare_id: this.$route.query.id
      }
      API.findInnovateTechnologyByPid(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.tableData2 = resp.data
        }
      })
    },
    // 提交承诺书
    submitPromise () {
      let params = {
        id: this.$route.query.id
      }
      API.updateIspromise(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.$router.push('/uploadFile?id=' + this.$route.query.id)
        }
      })
    },
    // 暂存
    tampSave () {
      if (!this.isAddedList.length && !this.tableData2.length) {
        this.$message.error('请填写技术目录')
        return
      }
      this.$message.success('暂存成功')
    },
    // 下一步
    next () {
      if (!this.isAddedList.length) {
        this.$message.error('请填写技术目录')
        return
      }
      if (this.$route.query.isSubmitted === 'true') {
        let params = {
          id: this.$route.query.id
        }
        API.backReplenishData(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.$router.push('/declare/submitted')
          }
        })
      } else {
        this.isShowPromise = true
      }
    },
    goback () {
      this.$router.go(-1)
    },
    changePane () {
      if (this.activeName !== '8' && this.activeName !== '9') {
        this.asyncGetTable()
      } else if (this.activeName === '8') {
        this.asyncFindInnovateTechnologyByPid()
      } else {
        this.asyncGetDeclareFile()
      }
    },
    addIntroduce (item) {
      this.level_id = item.level_id
      this.item = item
      this.isShowIntroduce = true
      this.number = item.number
      this.technology_name = item.technology_name
      this.technology_content = item.technology_content
      this.asyncQueryDeclareLevelByPidAndLevelid(item)
    },
    del (item) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          project_declare_id: this.$route.query.id,
          level_id: item.level_id
        }
        API.deleteDeclareLevelBydlId(params).then(resp => {
          if (resp.resultCode === '0000') {
            this.asyncGetTable()
          }
        })
      })
    },
    sure () {
      if (!this.form.dlfileaddress.length) {
        this.$message.error('请上传技术证明材料')
        return
      }
      if (!this.form.technology_introduce) {
        this.$message.error('请输入简介及介绍')
        return
      }
      let params = {
        project_declare_id: this.$route.query.id,
        level_id: this.item.id,
        technology_introduce: this.form.technology_introduce,
        dlfileaddress: this.form.dlfileaddress
      }
      this.loading1 = true
      API.createDeclareLevel(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.loading1 = false
          this.isShowIntroduce = false
          this.asyncGetTable()
          this.asyncGetEBByID()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.technologyListMain {
  .addInnovate {
    .el-dialog__header {
      border-bottom: 1px solid #dcdfe6;
      background: #f8f8f8;
      padding: 16px 20px;
    }
  }
  .textContent {
    width: 100%;
    margin: 80px 0;
    padding-left: 100px;
    p {
      font-size: 24px;
      color: #333;
      font-weight: normal;
      white-space: nowrap;
    }
  }
  .score {
    display: flex;
    align-items: center;
    margin-left: 70%;
  }
  .caption {
    color: #409eff;
    height: 50px;
    display: flex;
    align-items: flex-end;
    margin-top: -18px;
    p {
      font-size: 18px;
    }
  }
  .el-tabs__item {
    font-size: 16px;
    font-weight: normal;
    padding: 0 35px;
  }
  .el-dialog__body {
    padding: 0 20px 30px;
  }
  .theme {
    width: 100%;
    height: 30px;
    background: #fff;
    border-bottom: 1px solid #00b0f0;
    .blueBg {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .name {
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      background: #00b0f0;
      color: #fff;
    }
  }
  .technologyContent {
    margin: 20px 40px;
    color: #606266;
    line-height: 30px;
    text-indent: 2em;
  }
  .el-form {
    padding-right: 40px;
  }
  .promiseMain {
    .promiseTitle {
      font-size: 22px;
      font-weight: 400;
      color: #717171;
      line-height: 60px;
      text-align: center;
    }
    .promiseContent {
      padding: 0 50px;
      font-weight: 400;
      color: #999;
      font-size: 16px;
      line-height: 40px;
      margin: 0 auto;
      .promiseInput {
        text-align: center;
        border: none;
        border-bottom: 1px solid #d1d1d1;
        font-size: 16px;
      }
      .promiseText {
        text-indent: 2em;
      }
    }
  }
}
</style>
